import React from 'react'
import { CompositeNavigationProp, RouteProp } from '@react-navigation/native'
import { createNativeStackNavigator, NativeStackNavigationProp } from '@react-navigation/native-stack'
import { AddContacts, ClassifyContacts, ImportContacts, MergeContacts } from '../../screens/contacts/addContacts'
import { ListingContacts, ListingContactsFilters } from '../../screens/contacts/listingContacts'
import { CardScanner } from '@screens'
import { FtSocialImport } from '../../screens/contacts/ftSocialImport/FtSocialImport'
import { FtSocialImportResults } from '../../screens/contacts/ftSocialImport/FtSocialImportResults'
import { FtSocialImportNetwork } from '../../screens/contacts/ftSocialImport/FtSocialImportNetwork'

export type ScreenContactProps<RouteName extends keyof ContactStackParamList> = {
  navigation: CompositeNavigationProp<
    NativeStackNavigationProp<ContactStackParamList, RouteName>,
    NativeStackNavigationProp<ContactStackParamList, keyof ContactStackParamList>
  >
  route: RouteProp<ContactStackParamList, RouteName>
}

export type ContactStackParamList = {
  ListContacts: undefined
  CardScanner: undefined
  AddContact: undefined
  AddContactsFilters: undefined
  ListingContactsFilters: {
    isSuggested?: boolean
  }
  SearchProfile: undefined
  ImportContacts: undefined
  ClassifyContacts: undefined
  MergeContacts: undefined
  FtSocialImport: undefined
  FtSocialImportNetwork: { network: string }
  FtSocialImportResults: { importId: string }
  //Conversation: ConversationParams
}

const ContactStack = createNativeStackNavigator<ContactStackParamList>()

export const ContactNavigator = () => {
  return (
    <ContactStack.Navigator screenOptions={{ headerShown: false }}>
      <ContactStack.Screen name="ListContacts" component={ListingContacts} />
      <ContactStack.Screen name="CardScanner" component={CardScanner} />
      <ContactStack.Screen name="AddContact" component={AddContacts} />
      <ContactStack.Screen name="ImportContacts" component={ImportContacts} />
      <ContactStack.Screen name="ClassifyContacts" component={ClassifyContacts} />
      <ContactStack.Screen name="MergeContacts" component={MergeContacts} />
      <ContactStack.Screen name="FtSocialImport" component={FtSocialImport} />
      <ContactStack.Screen name="FtSocialImportNetwork" component={FtSocialImportNetwork} />
      <ContactStack.Screen name="FtSocialImportResults" component={FtSocialImportResults} />
      <ContactStack.Screen name="ListingContactsFilters" component={ListingContactsFilters} />
      {/*<ContactStack.Screen name="Conversation" component={Conversation} />*/}
    </ContactStack.Navigator>
  )
}
